import React from "react";
import './Footer.css';
import footerLogo from '../../Assets/logo.svg';
import userIcon from '../../Assets/user_icon.svg';
import { FaLinkedin, FaGithub, FaTwitter } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="footer-top-left">
                    <img src={footerLogo} alt="Footer Logo" />
                    <p>Stay updated with our latest news and offers</p>
                </div>
                <div className="footer-top-right">
                    <div className="footer-email-input">
                        <img src={userIcon} alt="User Icon" />
                        <input type="email" placeholder="Enter Your Email" />
                    </div>
                    <button className="footer-subscribe">SUBSCRIBE</button>
                </div>
            </div>
            <hr />
            <div className="footer-bottom">
                <p className="footer-bottom-left">© 2025 Arya Gupta. All Rights Reserved.</p>
                <div className="footer-bottom-right">
                    <a href="https://www.linkedin.com/in/arya-gupta-5968ab289/" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin />
                    </a>
                    <a href="https://github.com/devAryagupta" target="_blank" rel="noopener noreferrer">
                        <FaGithub />
                    </a>
                    <a href="https://x.com/home" target="_blank" rel="noopener noreferrer">
                        <FaTwitter />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;